// extracted by mini-css-extract-plugin
export default {"searchResultInfo":"style_searchResultInfo__CiKLD","headline":"style_headline__ADqth","loadMoreButton":"style_loadMoreButton__lwt5r","refreshIcon":"style_refreshIcon__4Vaw7"};